import React from "react";
import { classnames, Button, Icon } from "@culturehq/components";

import { useDelayedCallback } from "app/hooks";
import { Trans } from "app/utils";

type AddTagButtonProps = {
  onClick: () => void;
};

const AddTagButton: React.FC<AddTagButtonProps> = ({ onClick }) => {
  const [added, onAdd] = useDelayedCallback(2000, onClick);

  return (
    <span className={classnames("add-tag", { "add-tag-anim": added })}>
      <Button icon="plus" inverted small onClick={onAdd}>
        <Trans>Add</Trans>
      </Button>
      {added && (
        <>
          <span className="add-tag--circle" />
          <span className="add-tag--check">
            <Icon icon="checkmark" />
          </span>
        </>
      )}
    </span>
  );
};

export default AddTagButton;
